import type {
  AppApi,
  EDITOR_TYPE,
  PageToAdd,
} from '@wix/wix-data-client-common'
import { generateCollectionIdAndName } from '@wix/wix-data-client-common'
import { getPresetDefinitionById } from '../business-logic/presets/getPresetDefinitionById'
import type { EditorSDK } from '@wix/wix-data-client-common-standalone'
import type { CollectionsApi } from '@wix/wix-code-collections-api'

type Params = {
  appApi: AppApi
  collectionsApi: CollectionsApi
  editorType: EDITOR_TYPE
  presetId: string
  origin: string
  isFirstTimeExperience?: boolean
  editorSdkProxy: EditorSDK
}

export const addPreset = async ({
  appApi,
  collectionsApi,
  editorType,
  presetId,
  origin,
  isFirstTimeExperience = false,
  editorSdkProxy,
}: Params) => {
  const preset = await getPresetDefinitionById(
    presetId,
    editorType,
    editorSdkProxy,
  )
  const pagesToAdd: PageToAdd[] = preset.pages.map(page => ({
    key: page.type,
  }))

  const allCollections = await collectionsApi.getAll()

  const { collectionId, collectionName } = generateCollectionIdAndName({
    allCollections,
    baseName: preset.collections[0].schema.displayName,
  })

  return appApi.addDynamicPages({
    presetId,
    pagesToAdd,
    collectionId,
    collectionName,
    biDefaults: {
      origin,
      is_first_data_modal: isFirstTimeExperience,
    },
  })
}
